import { QueryClient } from '@tanstack/react-query';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Return cached data while fetching new data in background
      staleTime: 2 * 60 * 1000, // 2 minutes (matches current appointmentService)
      gcTime: 10 * 60 * 1000, // 10 minutes garbage collection (was cacheTime in v4)

      // Retry configuration
      retry: 2,
      retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 10000),

      // Don't refetch on window focus by default (can override per-query)
      refetchOnWindowFocus: false,

      // Stale-while-revalidate: show stale data while fetching
      placeholderData: (previousData: unknown) => previousData,
    },
    mutations: {
      // Retry mutations once on failure
      retry: 1,
    },
  },
});
